import { c as _c } from "react/compiler-runtime";
import { ProsAndCons as WrappedProsAndCons } from '@cc-shopping/ui/composites/ProsAndCons';
import { Box } from '@mui/material';
import { tableOfContentsMap } from 'src/app/credit-cards/reviews/components/Body/TableOfContents/constants';
import { useReviewContext } from 'src/app/credit-cards/reviews/components/Context';
export function ProsAndCons() {
  const $ = _c(3);
  const {
    prosBullets,
    consBullets
  } = useReviewContext();
  if (prosBullets.length <= 0 && consBullets.length <= 0) {
    return null;
  }
  let t0;
  if ($[0] !== consBullets || $[1] !== prosBullets) {
    t0 = <Box width="100%" id={tableOfContentsMap.PROS_AND_CONS.id}><WrappedProsAndCons pros={prosBullets} cons={consBullets} /></Box>;
    $[0] = consBullets;
    $[1] = prosBullets;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}